var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



/*****************
 ** WEBPACK FOOTER
 ** ./~/reactcss/~/lodash/_nativeCreate.js
 ** module id = 1327
 ** module chunks = 0
 **/